import React from "react";
import {SearchForm} from "./searchForm"
import VehicleList from "./vehicleList"
const Vehicle = ():JSX.Element => {
    return (
        <>
            <SearchForm/>
            <VehicleList/>
        </>
    )
}
export default Vehicle